import { useState } from 'react';

import { ValidationData } from '@components/MailpieceActions/types';

import { uploadValidationImage } from '../uploadValidationImage';

type UseCameraValidationParams = {
  pieceId?: number;
  isValidated: (pieceId: number) => boolean;
  addValidation: (pieceId: number, result: ValidationData[number]) => void;
};

export const useCameraValidation = ({ pieceId, isValidated, addValidation }: UseCameraValidationParams) => {
  const [cameraOpen, setCameraOpen] = useState(false);
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  const openCamera = () => setCameraOpen(true);

  const cancelCamera = () => {
    setCapturedImage(null);
    setCameraOpen(false);
  };

  const retakePhoto = () => setCapturedImage(null);

  const usePhoto = async () => {
    if (pieceId && !isValidated(pieceId) && capturedImage) {
      try {
        setUploadingImage(true);
        const key = await uploadValidationImage(pieceId, capturedImage);
        addValidation(pieceId, { validationImageKey: key });
      } catch (error) {
        console.error('Failed to upload validation image:', error);
        return;
      } finally {
        setUploadingImage(false);
      }
    }
    cancelCamera();
  };

  return {
    cameraOpen,
    capturedImage,
    setCapturedImage,
    uploadingImage,
    openCamera,
    cancelCamera,
    retakePhoto,
    usePhoto,
  };
};
